import { type QSetConditionsTags } from '@exam-management/graphql';

const CALCULATION_LABEL = {
  ['คำนวณ']: 'คำนวณ',
  ['ไม่คำนวณ']: 'ไม่คำนวณ',
};

export function formatQuestionCalculationTags(tags: QSetConditionsTags[]) {
  const formattedTags = Object.keys(CALCULATION_LABEL).map((calculation) => {
    const needTotal = tags.find((tag) => tag.tag.name === calculation)?.count;
    return `${calculation}: ${needTotal ?? '-'} ข้อ`;
  });

  return formattedTags.length ? formattedTags.join(', ') : '-';
}
